import { useEffect, useMemo, useState } from "react";

import prepareForOptions from "~services/utils/prepareForOptions";

import { db } from "~/db/db";

const useFilialV2 = ({ filiaisDisponiveis, camposOpt = ["codigo", "nome"] }) => {
  const [filiais, setFiliais] = useState([]);

  useEffect(() => {
    const fetchFiliais = async (signal) => {
      let query = db.filiais;
      let result = [];

      if (filiaisDisponiveis?.length > 0) {
        query = query.where("id").anyOf(filiaisDisponiveis);

        query = query.filter((a) => a.ativo);
        await query.each((item) => result.push(item));

        if (!signal.aborted) {
          setFiliais(result);
        }
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchFiliais(signal);

    return () => {
      controller.abort();
    };
  }, [filiaisDisponiveis]);

  const optionFiliais = useMemo(
    () =>
      prepareForOptions(
        (filiais || []).sort((a, b) => a.nome?.localeCompare(b.nome)),
        camposOpt,
        "id"
      ),
    [filiais]
  );

  return {
    filiais,
    optionFiliais,
  };
};

export default useFilialV2;
